import React from 'react';
import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { Section, SectionContent, SectionHeader } from 'src/shared/components';

import AboutLogo from './components/AboutLogo/AboutLogo';
import AboutPanel from './components/AboutPanel/AboutPanel';

const AboutSection = () => {
	const { t } = useTranslation();

	return (
		<Section name="about" animation="fadeIn">
			<SectionHeader title={t('aboutSection.header.title')} description={t('aboutSection.header.description')} />
			<SectionContent>
				<Col md={6}>
					<AboutPanel />
				</Col>
				<Col md={6}>
					<AboutLogo />
				</Col>
			</SectionContent>
		</Section>
	);
};

export default AboutSection;
